/* menu-variant.js - With proper time tracking */

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + d.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
}

var startTime = Date.now();
var gaValue;

function pushAnalyticsEvent(variant) {
  gaValue = variant === "2" ? "variant" : "control";
  
  // Method 1: Set as user property (recommended for A/B tests)
  function setUserProperty() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "set_user_properties",
      user_properties: {
        menu_variant: gaValue
      }
    });
    console.log("User property set:", gaValue);
  }

  // Method 2: Enhanced page_view with experiment data
  function enhancePageView() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "experiment_exposure",
      experiment_name: "menu_variant_test",
      variant_name: gaValue,
      menu_variant: gaValue
    });
    console.log("Experiment exposure tracked:", gaValue);
  }

  setUserProperty();
  enhancePageView();

  // gtag.js version
  if (typeof window.gtag === "function") {
    try {
      // Set user property for all future events
      window.gtag("set", "user_properties", {
        menu_variant: gaValue
      });
      
      // Track experiment exposure
      window.gtag("event", "experiment_exposure", {
        experiment_name: "menu_variant_test",
        variant_name: gaValue
      });
      
      console.log("gtag tracking set up for:", gaValue);
    } catch (e) {
      console.warn("gtag error:", e);
    }
  }
}

// Track time-based events
function trackTimeBasedEvents() {
  var intervals = [10000, 30000, 60000, 120000]; // 10s, 30s, 1m, 2m
  
  intervals.forEach(function(interval) {
    setTimeout(function() {
      var timeOnSite = Math.round((Date.now() - startTime) / 1000);
      
      // GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "time_on_site_milestone",
        time_seconds: timeOnSite,
        menu_variant: gaValue,
        milestone: interval / 1000 + "s"
      });
      
      // gtag
      if (typeof window.gtag === "function") {
        window.gtag("event", "time_on_site_milestone", {
          time_seconds: timeOnSite,
          milestone: interval / 1000 + "s",
          menu_variant: gaValue
        });
      }
      
      console.log("Time milestone:", interval / 1000 + "s", "Total time:", timeOnSite + "s");
    }, interval);
  });
}

// Track page unload with final time
function trackFinalTime() {
  window.addEventListener("beforeunload", function() {
    var finalTime = Math.round((Date.now() - startTime) / 1000);
    
    // Use sendBeacon for reliable sending on page unload
    if (navigator.sendBeacon && typeof window.gtag === "function") {
      window.gtag("event", "session_complete", {
        session_duration: finalTime,
        menu_variant: gaValue,
        transport_type: "beacon"
      });
    }
    
    console.log("Final session time:", finalTime + "s");
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var cookieName = "menuVariant";
  var variant = getCookie(cookieName);

  if (!variant) {
    variant = Math.random() < 0.5 ? "1" : "2";
    setCookie(cookieName, variant, 30);
    console.log("New variant assigned:", variant);
  } else {
    console.log("Existing variant found:", variant);
  }

  // Apply CSS changes for variant 2
  if (variant === "2") {
    document
      .querySelectorAll(".site-navigation-wrapper, .site-navigation")
      .forEach(function (el) {
        el.classList.add("variant-bg");
      });
    console.log("Variant 2 CSS applied");
  }

  // Set up analytics tracking
  pushAnalyticsEvent(variant);
  
  // Start time-based tracking
  trackTimeBasedEvents();
  trackFinalTime();
});